import React, { useState, useEffect } from 'react';
import { Row, Col, InputGroup } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import Head from '../../components/navbar/Head.js';
import NavBar from '../../components/navbar/NavBar.js';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { useNavigate, useLocation } from 'react-router-dom';
import DotRed from '../../image/dot_red.png';
import DotGreen from '../../image/dot_green.png';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { limitPageEbookDetails } from '../../api/index.js'
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { getBookRelatedShelfs, deleteBookRelatedShelf , searchBookRelatedShelfs } from '../../api';
import { useDispatch, useSelector } from 'react-redux';
import { dialogConfirmSetData, dialogConfirmSetShowModal } from '../../actions/confirmDialog.action.js';

const ShelfEbookRelated = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { pagesTabId } = location.state || {};

    const [shelfDetails, setShelfDetails] = useState([]);
    const [formData, setFormData] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const shelfSortOption = useSelector(state => state.site.bookRelatedShelfSortOption);
    const [sortColumn, setSortColumn] = useState(shelfSortOption);

    useEffect(() => {    
        fetchShelfDetails(currentPage, sortColumn);
    }, []);
   
    const handleSearch = () => {

        // "movieTitle" =Movie Title
        // "shelfTitle" =Shelf Title
        // "status" = Status

        const keyword = formData.keyword || '';
        const filterColumn = formData.filterColumn || 'movieTitle'; 
        searchBookRelatedShelfs(keyword, filterColumn, 1, limitPageEbookDetails).then(response => {
            if (response.data.error === false && response.data.result !== null) {
                setTotalItems(response.data.result.count);
                let result = response.data.result.data;
                setShelfDetails(result);
            }
        });
    }

    const handleChange = (event) => {

        const { name, value } = event.target || '';
        setFormData((prevData) => ({ ...prevData, [name]: value }));
        if (event.key === 'Enter') {
            handleSearch();
        }
    }

    function handleEditShelf(shelfId) {
        navigate('/ManageShelfEbookRelated', {
            state: {
                shelfId: shelfId ,
            },
        });
    }

    function handleDeleteShelf(shelfId) {
        dispatch(dialogConfirmSetData({
            title: "Confirm Shelf Deletion",
            message: " Are you sure you want to delete this shelf?",
            closeButton: "Cancel",
            confirmButton: "Confirm",
            eventConfirmButton: () => deleteBookRelatedShelf(shelfId).then(response => {
                const newData = shelfDetails.filter(item => item.shelf_id !== shelfId);
                setShelfDetails(newData);
            }),
            eventCloseButton: () => null,
            showCloseButton: true
        }));
        // ** ทำให้ dialog โชว์ขึ้นมา **
        dispatch(dialogConfirmSetShowModal(true));
    }

    const buttonNewShelfClick = () => {
        navigate('/ManageShelfEbookRelated', {
            state: {
                pagesTabId: pagesTabId ,
            },

        });
    }

    function fetchShelfDetails(page, sortColumn) {
        
        getBookRelatedShelfs(page, limitPageEbookDetails, []).then(response => {

            if (response.data.error === false && response.data.result !== null) {
                setTotalItems(response.data.result.count);
                let result = response.data.result.data;
                setShelfDetails(result);
            }
        });
    }

    const columns = [
        {
            field: 'row_num', 
            header: 'No.', 
            render: (rowData) => (
                <p className='td-text'>
                    {rowData.row_num}
                </p>
            ) , 
        },
        {
            field: 'video_title', header: 'Video Title', render: (rowData) => (
                <p className='td-text'>
                    {rowData.video_title}
                </p>
            )
        },
        {
            field: 'shelf_title', header: 'Shelf Title', render: (rowData) => (
                <p className='td-text'>
                    {rowData.shelf_title}
                </p>
            )
        },
        {
            field: 'contents_id', header: 'Number of Items', render: (rowData) => (
                <p className='td-text'>
                    {rowData.content_id.split(",").length}
                </p>
            )
        },
        {
            field: 'shelf_active', header: 'Status', render: (rowData) => (
                <p className='td-text'>
                    {rowData.shelf_active === '1' && (
                        <React.Fragment>
                            <img src={DotGreen} width='12px' className='str_icon' alt='Active' />
                            {'Active'}
                        </React.Fragment>
                    )}
                    {rowData.shelf_active === '0' && (
                        <React.Fragment>
                            <img src={DotRed} width='12px' className='str_icon' alt='Inactive' />
                            {'Inactive'}
                        </React.Fragment>
                    )}
                </p>
            )
        },
        {
            field: 'Action', header: 'Action', render: (rowData) => (
                <div>
                    <button onClick={() => handleEditShelf(rowData.shelf_id)}
                        className='normal-link link-button'>
                        Edit
                    </button>
                    {' | '}
                    <button onClick={() => handleDeleteShelf(rowData.shelf_id)}
                        className='delete-link link-button'>
                        Delete
                    </button>
                </div>
            )
        }
    ];

    const dynamicColumns = columns.map((col, i) => {
        return <Column reorderable={false} reorderableColumns={false} key={col.field} columnKey={col.field} field={col.field} header={col.header} body={col.render} className={col.field === 'display_order' ? 'fixed-width-column' : ''} />;
    });

    const handleBackClick = (url) => {
        navigate('/'+url, {
         state: {
             pagesTabId: pagesTabId
         },
         replace: true,
     });
    }

    return (
        <div >
            <Head />
            <Row className='row-navbar'>
                <NavBar />
                <Col className='row-context' >
                    <main>
                        <div className='box-context'>
                            <div className='div-row-col'>
                                <Row sm={12}>

                                    <span className='title-text'> 
                                        <div className='title-content-text' onClick={() => handleBackClick('ShelfEbookRelated')}>Shelf Book Related</div>
                                    </span>
                                    <p className='context-text'>Organize and update your ebook related in movie details page.</p>

                                    <Col sm={12} md={5}>  <Button onClick={() => buttonNewShelfClick()} className='button-action button-main button-orange' variant="primary" type="submit">+ New Section</Button></Col>
                                    <Col sm={12} md={7}>
                                        <InputGroup>

                                            <Form.Control style={{ width: '150px' }} className='form-control-custom' name='keyword'
                                                placeholder="Search..." aria-label="Search..."
                                                onKeyUp={(e) => {
                                                    handleChange(e);
                                                }}
                                            />

                                            <Form.Select name='filterColumn' onChange={handleChange} className='form-control-custom2' style={{ width: '20px', borderBottomRightRadius: '5px', borderTopRightRadius: '5px', fontFamily: 'Sukhumvit Set' }} >
                                                <option value="movieTitle">Movie Title</option>
                                                <option value="shelfTitle">Shelf Title</option>
                                                <option value="status">Status</option>
                                            </Form.Select>

                                            <div md={1} style={{ marginLeft: '10px' }}>
                                                <Button className='button-search button-main button-white' variant="primary" onClick={() => {
                                                    handleSearch();
                                                }} >Search</Button>
                                            </div>
                                        </InputGroup>
                                    </Col>
                                </Row>

                            </div>

                            <div className='box-table'>
                                <Card className='card-box'>
                                    <Card.Body style={{ fontFamily: 'Sukhumvit Set' }}>
                                        <Col className='' >
                                            <main>
                                                <div className=''>
                                                    <div className=''>
                                                        <DataTable value={shelfDetails} reorderableColumns={false} className="reorder-datatable" tableStyle={{ width: '100%' }}  >
                                                            {dynamicColumns}
                                                        </DataTable>
                                                    </div>
                                                </div>
                                            </main>
                                        </Col>
                                    </Card.Body>

                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '32px', marginBottom: '15px' }}>
                                        <PaginationControl
                                            page={currentPage}
                                            between={4}
                                            total={totalItems}
                                            limit={limitPageEbookDetails}
                                            changePage={(page) => {
                                                setCurrentPage(page);
                                                fetchShelfDetails(page, sortColumn);
                                            }}
                                            ellipsis={10}
                                        />
                                    </div>

                                </Card>
                            </div>
                        </div>

                    </main>
                    
                </Col>
            </Row>
        </div>
    );

}


export default ShelfEbookRelated;